import { useCallback } from 'react';

export const useUIControl = () => {
  const clearOverlays = useCallback(() => {
    window.dispatchEvent(new CustomEvent('ui:clearOverlays'));
  }, []);

  const onClearOverlay = (handler: () => void) => {
    window.addEventListener('ui:clearOverlays', handler);
    return () => {
      window.removeEventListener('ui:clearOverlays', handler);
    };
  };

  return { clearOverlays, onClearOverlay };
};
